"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTranslations = void 0;
var defaultTranslations = {
  back: "Back",
  day: "day",
  days: "days",
  setTimeOut: "Set Time Out",
  savedMessage: "Time Out Saved",
  coolingOffMessage: "You have chosen to take a break for $1 $2. You can play again on $3",
  coolingOffExplanation: "If you want to give yourself a break from playing low6 for up to 6 weeks, you can do so by selecting an option below."
};
exports.defaultTranslations = defaultTranslations;